import {statusBorderColor, statusColor, statusFontColor} from '../../../../../enums/statusColorEnum';
import { status } from '../../../../../enums/statusEnum';
import NotInformation from '../../../../../components/NotInformation';
import HeadTittle from "../../../../../components/HeadTittle";
import routes from "../../../../../Routes/routes";
import {
    CompletePersonChip,
    EmailSubsectionChip,
    IconBuildingTable, IconClockTable, IconColorPalette, IconDocumentLines, IconDocumentMedal, IconPersonDefaultV2,
    IconScheduleTable,
    IconShoppingCar, IconVehicle, IconVehicleDefault,
    MobileIcon, ModelIcon, PersonBook, PhoneSubsectionChip
} from "../../../../../components/buttons/IconButtons";
import CustomChip from "../../../../../components/CustomChip";
import {DATE_TIME_FORMAT_NAME_MODEL, EMPTY_VALUES, getDateFormat, getFullName} from "../../../../../Apis/functions";
import {USER_TYPE_NAME_MODEL} from "../../../../../enums/userTypeEnum";
import RowCardText from "../../../../../components/RowCardText";
import {OrderDetailApp} from "../../Functionality/OrderDetailApp";
import CustomCard from "../../../../../components/CustomCard";
import CustomTooltip from "../../../../../components/CustomTooltip";
import CustomGenericTittleIconDataChip from "../../../../../components/CustomGenericTittleIconDataChip";
import CustomCardGridGeneral from "../../../../../components/CustomCardGridGeneral";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 * @returns {JSX.Element}
 * @constructor
 */

const OrderDetail = () => {

    const {
        userType,
        supplierEmployeeUser,
        supplierVehicle,
        t,
        getOrderDetails,
        availableHeightColumnOneRef,
        availableHeightColumnTwoRef,
        containerHeightRef,
        renderEmployeeButton,
        renderVehicleButton
    } = OrderDetailApp();

    return (
        <>
            <HeadTittle name={'details'} link={
                userType === USER_TYPE_NAME_MODEL.EMPLOYEE
                ? routes.suppliers.main
                : userType === USER_TYPE_NAME_MODEL.SUPPLIER_IN_CHARGE
                    ? routes.suppliers.orders
                    : null
            }
            />
            <div className='row px-0 h-100'>
                <div className='col-12 col-lg-4 mb-lg-0 mb-md-3 mb-sm-3 pl-0' ref={availableHeightColumnOneRef}>
                    <CustomCard classes={'h-100'} classCard={'card-border-8px'} classContent={'p-0'}>
                        <div className='d-flex flex-wrap  justify-content-between align-items-center m-3'>
                            <CustomGenericTittleIconDataChip
                                title={'purchase_orders_details'}
                                Icon={IconDocumentLines}
                                border={false}
                                classNameTittleContainer={'justify-content-center'}
                                titleBoxClass={'d-flex'}
                            />
                            <CustomChip
                                className={"col-4"}
                                variant={'large'}
                                background={statusColor[getOrderDetails?.status?.id]}
                                fontColor={statusFontColor[getOrderDetails?.status?.id]}
                                borderColor={statusBorderColor[getOrderDetails?.status?.id]}
                                legend={t(status[getOrderDetails?.status?.id]) || EMPTY_VALUES.DEFAULT}
                            />
                        </div> <div className={'border-bottom-shades-300'} />
                           
                            <div className='row align-items-start p-3 overflow-y-auto' ref={containerHeightRef} >
                                <div className='col-2 p-0'>
                                    <div className='p-8px border-radius-8px d-flex w-44px h-44px justify-content-center background-secondary-100 mt-4'>
                                        <IconDocumentMedal className='btn-icon-svg-24px' />
                                    </div>
                                </div>
                                <div className='col-10'>
                                    <div className='row my-4 px-0 ml-0 pl-0'>
                                        <div className='pl-0 ml-0'>
                                            <CustomTooltip
                                                text={getOrderDetails?.folio?.toUpperCase() || EMPTY_VALUES.DEFAULT}
                                                classes={`ffs-14px font-color-general-950 text-ellipsis-1-row ibl-font-w-600 pl-0 ml-0`}
                                                showIfTruncated={true}
                                            />
                                        </div>
                                        <div className='col-12 px-0'>
                                            <div className='d-flex align-items-center'>
                                                <IconBuildingTable />
                                                <CustomTooltip
                                                    text={getOrderDetails?.supplier?.acronym}
                                                    classes={'font-color-general-950 fs-14px ml-2'}
                                                    showIfTruncated={true}
                                                    placement={'top'}
                                                />
                                            </div>
                                        </div>
                                        <div className='border-bottom-shades-300 mt-3' />
                                        <div className='col-12 px-0'>
                                            <p className='font-color-general-950 fs-14px ibl-font-w-600 px-0 my-3'>
                                                {t('supplier_information')}
                                            </p>
                                            <div className={'flex-grow-1 minw-0'}>
                                                <CustomTooltip
                                                    text={getOrderDetails?.supplier?.user?.fullName}
                                                    classes={`fs-14px font-color-general-950 text-ellipsis-1-row px-0 mt-3 mb-1`}
                                                    showIfTruncated={true}
                                                />
                                            </div>
                                            <div className={'d-flex justify-content-between p-0 gap-3 '}>
                                                <div className={'d-flex flex-grow-1 minw-0 align-items-center'}>
                                                    <div className={'mr-2 d-flex align-items-center'}>
                                                        <EmailSubsectionChip />
                                                    </div>
                                                    <div className={'flex-grow-1 minw-0'}>
                                                        <CustomTooltip
                                                            text={getOrderDetails?.supplier?.user?.email}
                                                            classes={`fs-14px font-color-general-950 text-ellipsis-1-row align-items-center`}
                                                            showIfTruncated={true}
                                                        />
                                                    </div>
                                                </div>
                                                <div className={'d-flex flex-grow-1 minw-0'}>
                                                    <div className={'mr-2 mb-1 d-flex align-items-center'}>
                                                        <MobileIcon className='icon-color-shades-800 flex-shrink-0' />
                                                    </div>
                                                    <div className={'flex-grow-1 minw-0'}>
                                                        <CustomTooltip
                                                            text={getOrderDetails?.supplier?.user?.phoneNumber}
                                                            classes={`fs-14px font-color-general-950 text-ellipsis-1-row`}
                                                            showIfTruncated={true}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='border-bottom-shades-300 mt-3' />
                                        <div className='col-12 px-0'>
                                            <p className='font-color-general-950 fs-14px ibl-font-w-600 px-0 my-3'>
                                                {t('item')}
                                            </p>
                                            <div className={'d-flex justify-content-between p-0 gap-3 '}>
                                                <div className={'d-flex flex-grow-1 minw-0'}>
                                                    <div className={'mr-2 mb-1 d-flex align-items-center'}>
                                                        <IconShoppingCar className='icon-color-shades-800 flex-shrink-0' />
                                                    </div>
                                                    <div className={'flex-grow-1 minw-0'}>
                                                        <CustomTooltip
                                                            text={getOrderDetails?.item}
                                                            classes={`fs-14px font-color-general-950 text-ellipsis-1-row`}
                                                            showIfTruncated={true}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='border-bottom-shades-300 mt-3'/>
                                        <div className='col-12 px-0'>
                                            <p className='font-color-general-950 fs-14px ibl-font-w-600 px-0 my-3'>
                                                {t('estimated_delivery_date')}
                                            </p>
                                            <div className={'d-flex justify-content-between p-0 gap-3 '}>
                                                <div className={'d-flex flex-grow-1 minw-0'}>
                                                    <div className={'mr-2 mb-1 d-flex align-items-center'}>
                                                        <IconScheduleTable className='icon-color-shades-800 flex-shrink-0' />
                                                    </div>
                                                    <div className={'flex-grow-1 minw-0'}>
                                                        <CustomTooltip
                                                            text={getDateFormat(getOrderDetails?.deliveryDate,false,DATE_TIME_FORMAT_NAME_MODEL.dayWithShortMonth)}
                                                            classes={`fs-14px font-color-general-950 text-ellipsis-1-row`}
                                                            showIfTruncated={true}
                                                        />
                                                    </div>
                                                </div>
                                                <div className={'d-flex flex-grow-1 minw-0'}>
                                                    <div className={'mr-2 mb-1 d-flex align-items-center'}>
                                                        <IconClockTable className='icon-color-shades-800 flex-shrink-0' />
                                                    </div>
                                                    <div className={'flex-grow-1 minw-0'}>
                                                        <CustomTooltip
                                                            text={getDateFormat(getOrderDetails?.deliveryDate,false,DATE_TIME_FORMAT_NAME_MODEL.time12Uppercase)}
                                                            classes={`fs-14px font-color-general-950 text-ellipsis-1-row`}
                                                            showIfTruncated={true}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className='border-bottom-shades-300 mt-3'/>
                                        <div className='col-12 px-0 gap-2 mt-3'>
                                            <p className='font-color-general-950 fs-14px ibl-font-w-600 px-0'>
                                                {t('order_description')}
                                            </p>
                                            <p className='font-color-general-950 fs-14px px-0'>
                                                {getOrderDetails?.description || EMPTY_VALUES.DEFAULT}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                     
                    </CustomCard>
                </div>
                <div className='col-12 col-lg-8 pl-0' ref={availableHeightColumnTwoRef}>
                    <CustomCard classes={'h-100'} classCard={'card-border-8px'} classContent={'p-0'}>
                        <div className='d-flex justify-content-between align-items-center m-3'>
                            <CustomGenericTittleIconDataChip
                                title={'delivery_entrance'}
                                Icon={PersonBook}
                                border={false}
                                titleBoxClass={'d-flex'}
                            />
                        </div>
                        <CustomCard classes={'mb-3'} classCard={'card-border-8px m-3'} classContent={'p-0 row mb-3'}>
                            <div className={"col-6"}>
                                <div className={'d-flex align-items-center m-3'}>
                                         <CustomGenericTittleIconDataChip
                                                        title={t('assigned_employee')}
                                                        Icon={CompletePersonChip}
                                                        border={false}
                                                        classNameTittleContainer={'mb-0'}
                                                        titleBoxClass={'d-flex'}
                                                    />
                                </div>
                                <div className={'border-bottom-shades-300 mb-3'} />
                                { supplierEmployeeUser ? (
                                    <CustomCardGridGeneral
                                        head={
                                            <>
                                                <div
                                                    className='h-144px img-container img-background-primary-20 d-flex
                                                    flex-column justify-content-center align-items-center gap-2 flex-fill
                                                    align-self-stretch position-relative overflow-hidden'
                                                >
                                                    {supplierEmployeeUser?.selfie && (
                                                        <img
                                                            src={`data:image/png;base64,${supplierEmployeeUser?.selfie}`}
                                                            alt='profile'
                                                            className='w-100 h-100 img-filter-background'
                                                        />
                                                    )}
                                                    <div className={'position-absolute gap-2 w-100 t-10px'}>
                                                        <div className={'pl-2 pr-20px'}>
                                                            <div className={'d-flex justify-content-end align-items-center'}>
                                                                <CustomChip
                                                                    legend={t(status[supplierEmployeeUser?.status?.id])}
                                                                    borderColor={statusBorderColor[supplierEmployeeUser?.status?.id]}
                                                                    fontColor={statusFontColor[supplierEmployeeUser?.status?.id]}
                                                                    background={statusColor[supplierEmployeeUser?.status?.id]}
                                                                    variant={'large'}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={'h-60px position-relative'}>
                                                    {supplierEmployeeUser?.selfie ? (
                                                        <div className={'position-absolute t-50-l-50 t-0-center'}>
                                                            <img
                                                                className={'w-120px h-120px image-card-grid'}
                                                                src={`data:image/png;base64,${supplierEmployeeUser?.selfie}`}
                                                                alt='add'
                                                            />
                                                        </div>
                                                    ) : (
                                                        <div className={'position-absolute t-50-l-50 t-0-center'}>
                                                            <IconPersonDefaultV2 />
                                                        </div>
                                                    )}
                                                </div>
                                            </>
                                        }
                                    >
                                        <div className='h-54px position-relative w-100'>
                                            <div className={'position-absolute t-50-l-50 w-100'}>
                                                <CustomTooltip
                                                    text={supplierEmployeeUser?.fullName || EMPTY_VALUES.DEFAULT}
                                                    classes={'ibl-h3 font-color-general-950 ibl-font-w-600 text-center text-ellipsis-2-rows'}
                                                    showIfTruncated={true}
                                                    placement={'top'}
                                                />
                                            </div>
                                        </div>

                                        <div className={'border-bottom-shades-300-2px'} />

                                        <div className='position-relative w-100 my-3'>
                                            <div className={'position-absolute t-50-l-50 w-100'}>
                                                <RowCardText
                                                    icon={<EmailSubsectionChip className='w-20px' />}
                                                    title={t('email')}
                                                    value={supplierEmployeeUser?.email || EMPTY_VALUES.DEFAULT}
                                                />
                                            </div>
                                        </div>

                                        <div className='position-relative w-100 mb-3'>
                                            <div className={'position-absolute t-50-l-50 w-100'}>
                                                <RowCardText
                                                    icon={<PhoneSubsectionChip className='w-20px' />}
                                                    title={t('phone_number')}
                                                    value={supplierEmployeeUser?.phoneNumber || EMPTY_VALUES.DEFAULT}
                                                />
                                            </div>
                                        </div>
                                        {renderEmployeeButton(supplierEmployeeUser)}
                                    </CustomCardGridGeneral>
                                ) : (
                                    <div className={'col-12 p-0'}>
                                        <NotInformation text={t('no_information')} card={true} />
                                    </div>
                                )}
                            </div>
                            <div className={"col-6"}>
                                <div className={'d-flex align-items-center m-3'}>
                                    <CustomGenericTittleIconDataChip
                                                        title={t('assigned_vehicle')}
                                                        Icon={IconVehicle}
                                                        border={false}
                                                        classNameTittleContainer={'mb-0'}
                                                        titleBoxClass={'d-flex'}
                                                    />
                                </div>
                                <div className={'border-bottom-shades-300 mb-3'} />
                                { supplierVehicle ? (
                                    <CustomCardGridGeneral
                                        head={
                                            <>
                                                <div className='h-144px img-container img-background-primary-20 d-flex
                                            flex-column justify-content-center align-items-center gap-2 flex-fill
                                            align-self-stretch position-relative overflow-hidden'
                                                >
                                                    {supplierVehicle?.selfie && (
                                                        <img src={`data:image/png;base64,${supplierVehicle?.selfie}`}
                                                             alt='profile' className='w-100 h-100 img-filter-background'
                                                        />
                                                    )}
                                                    <div className={'position-absolute gap-2 w-100 t-10px'}>
                                                        <div className={'pl-2 pr-20px'}>
                                                            <div className={'d-flex justify-content-end align-items-center'}>
                                                                <CustomChip
                                                                    legend={t(status[supplierVehicle?.status?.id])}
                                                                    borderColor={statusBorderColor[supplierVehicle?.status?.id]}
                                                                    fontColor={statusFontColor[supplierVehicle?.status?.id]}
                                                                    background={statusColor[supplierVehicle?.status?.id]}
                                                                    variant={'large'}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={'h-60px position-relative'}>
                                                    {supplierVehicle?.selfie ? (
                                                        <div className={'position-absolute t-50-l-50 t-0-center'}>
                                                            <img
                                                                className={'w-120px h-120px image-card-grid'}
                                                                src={`data:image/png;base64,${supplierVehicle?.selfie}`}
                                                                alt='add'
                                                            />
                                                        </div>
                                                    ) : (
                                                        <div className={'position-absolute t-50-l-50 t-0-center'}>
                                                            <IconVehicleDefault className='h-141 w-141px' />
                                                        </div>
                                                    )}
                                                </div>
                                            </>
                                        }
                                    >
                                        <div className='h-54px position-relative w-100'>
                                            <div className={'position-absolute t-50-l-50 w-100'}>
                                                <CustomTooltip
                                                    text={getFullName(
                                                        supplierVehicle?.brand || EMPTY_VALUES.DEFAULT,
                                                        supplierVehicle?.subBrand || EMPTY_VALUES.DEFAULT,
                                                    )}
                                                    classes={
                                                        'ibl-h3 font-color-general-950 ibl-font-w-600 text-center text-ellipsis-2-rows'
                                                    }
                                                    showIfTruncated={true}
                                                    placement={'top'}
                                                />
                                            </div>
                                        </div>

                                        <div className={'border-bottom-shades-300-2px'} />

                                        <div className='position-relative w-100 my-3'>
                                            <div className={'position-absolute t-50-l-50 w-100'}>
                                                <RowCardText
                                                    icon={<ModelIcon className='w-20px' />}
                                                    title={t('model')}
                                                    value={supplierVehicle?.model || EMPTY_VALUES.DEFAULT}
                                                />
                                            </div>
                                        </div>

                                        <div className='position-relative w-100 mb-3'>
                                            <div className={'position-absolute t-50-l-50 w-100'}>
                                                <RowCardText
                                                    icon={<IconColorPalette className='w-20px' />}
                                                    title={t('color')}
                                                    value={supplierVehicle?.color || EMPTY_VALUES.DEFAULT}
                                                />
                                            </div>
                                        </div>
                                        {renderVehicleButton(supplierVehicle)}
                                    </CustomCardGridGeneral>
                                ) : (
                                    <div className={'col-12 p-0'}>
                                         <NotInformation text={t('no_information')} card={true} />
                                    </div>
                                    )}
                            </div>
                        </CustomCard>
                    </CustomCard>
                </div>
            </div>
        </>
    );
};

export default OrderDetail;
